module.exports = __webpack_public_path__ + "static/media/guitar.6a5651da.svg";